import { Component, OnInit } from '@angular/core';
import { Router, Route, NavigationStart } from '@angular/router';
import { UserModel, UsersService } from 'src/app/Api_Module';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { routes } from 'src/app/app-routing.module';
import { Observable, of, timer, Subject, BehaviorSubject } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'crg-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor(private router: Router, private userService: UsersService, public authServc: AuthenticationService) { }

  menus: Observable<any[]>;
  private menuList: BehaviorSubject<any[]> = new BehaviorSubject([]);

  ngOnInit() {
    this.menus = this.menuList.asObservable().pipe(debounce(() => timer(100)));
    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          this.menuList.next(this.getMenus());
        }
      }
    );
  }

  getMenus(): any[] {
    const myMenu: {name: string, icon: string, path: string}[] = new Array();

    const eligibleRoutes = routes.filter((route) => !!route.canActivate && !!route.data && !!route.data['allowedRoles']);
    eligibleRoutes.forEach((menuRoute: Route, index) => {
      const menuItem  = {};
      menuItem['name'] = menuRoute.data['name'] ? menuRoute.data['name'] : 'Menu' + index;
      menuItem['icon'] = menuRoute.data['icon'] ? ' fa fa-' + menuRoute.data['icon'] : '';
      menuItem['path'] = menuRoute.path;
      const roles = menuRoute.data['allowedRoles'];
      if (this.authServc.isLoggegIn() && this.authServc.isUserInRoles(roles)) {
        myMenu.push(menuItem as {name: string, icon: string, path: string});
      }
    });
    return myMenu;
  }

  logout() {
    localStorage.removeItem('currentUser');
    this.router.navigate(['login']);
  }

}
